<template>
  <div class="loading-container">
    <div class="mask"></div>
    <div class="loaderanimate">
      <!-- <svg-icon class="a-anniuloading-013"></svg-icon> -->
      <icon-svg
        icon-class="ic-a-anniuloading-013"
        size="80"
        class="icon loading" />
    </div>
    <div class="custom-progress-box">
      <div class="progress-box">
        <el-progress
          class="progress-primary"
          :show-text="false"
          :percentage="progress"
          :stroke-width="8">
        </el-progress>
        <div class="custom-text">{{ `${progress}%` }}</div>
      </div>
      <div
        v-if="status === 1"
        class="description-box">
        <div>排队中，请稍后...</div>
        <div
          class="common-button-box"
          v-if="upgradeFlag">
          <el-button
            class="text-btn"
            type="text"
            @click="backDataManage">
            点击此处
          </el-button>
          查看具体进度
        </div>
      </div>
      <div
        v-if="status === 2"
        class="description-box">
        <div>应用中，请稍后...</div>
        <div
          class="common-button-box"
          v-if="upgradeFlag">
          <el-button
            class="text-btn"
            type="text"
            @click="backDataManage">
            点击此处
          </el-button>
          查看具体进度
        </div>
      </div>
      <div
        v-if="status === 10"
        class="description-box">
        纹理应用成功，<span class="time">{{ time }}s</span>后重新加载页面
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { time: 5 }
  },
  props: {
    upgradeFlag: Boolean,
    status: Number,
    progress: Number
  },
  watch: {
    status: function (newVal) {
      if (newVal === 10) {
        this.updateTime()
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    backDataManage() {
      let { projId, projName } = this.$route.params
      let { dataType } = this.$route.query
      let dataSetInfo = sessionStorage.getItem('BimDataSetInfo')
      dataSetInfo = JSON.parse(dataSetInfo)

      const routerUrl = this.$router.resolve({
        path: `../../dataManage/${projId}/${encodeURIComponent(projName)}`,
        query: { dataType }
      })

      window.open(routerUrl.href, '_blank')
    },
    updateTime() {
      this.timer = setInterval(() => {
        this.time--
        if (this.time === 1) {
          clearInterval(this.timer)
        }
      }, 1000)
    }
  }
}

</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.loading-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .mask {
    position: absolute;
    width: calc(100% + 2px);
    height: 100%;
    background: var(--dialog-mask-bgColor);
    z-index: 1;
    margin-left: -1px;
    margin-right: -1px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .loaderanimate {
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 2;
    margin-bottom: 14px;
    .loading{
      animation: spin 1.5s linear infinite; /* 关键帧动画 */
    }

    :deep(.svg-icon){
      color: var(--base-primary-color);
    }
  }

  /* 定义旋转动画 */
  @keyframes spin {
    0% {
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg); /* 兼容旧版浏览器 */
    }
    100% {
      transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
    }
  }

  .loader {
    position: absolute;
    top: calc(50% - 60px);
    left: calc(50% - 24px);
    font-size: 20px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    text-indent: -1em;
    animation: load-effect 1s infinite linear;
    z-index: 2;

    @keyframes load-effect {
      0% {
        box-shadow: 0 -3em 0 0.2em #3f8cf6, 2em -2em 0 0 #3f8cf6,
          3em 0 0 -0.5em #3f8cf6, 2em 2em 0 -0.5em #3f8cf6,
          0 3em 0 -0.5em #3f8cf6, -2em 2em 0 -0.5em #3f8cf6,
          -3em 0 0 -0.5em #3f8cf6, -2em -2em 0 0 #3f8cf6;
      }

      12.5% {
        box-shadow: 0 -3em 0 0 #3f8cf6, 2em -2em 0 -0.5em #3f8cf6,
          3em 0 0 -0.5em #3f8cf6, 2em 2em 0 -0.5em #3f8cf6,
          0 3em 0 -0.5em #3f8cf6, -2em 2em 0 0 #3f8cf6, -3em 0 0 0 #3f8cf6,
          -2em -2em 0 0.2em #3f8cf6;
      }

      25% {
        box-shadow: 0 -3em 0 -0.5em #3f8cf6, 2em -2em 0 -0.5em #3f8cf6,
          3em 0 0 -0.5em #3f8cf6, 2em 2em 0 -0.5em #3f8cf6,
          0 3em 0 -0.5em #3f8cf6, -2em 2em 0 0 #3f8cf6, -3em 0 0 0.2em #3f8cf6,
          -2em -2em 0 0 #3f8cf6;
      }

      37.5% {
        box-shadow: 0 -3em 0 -0.5em #3f8cf6, 2em -2em 0 -0.5em #3f8cf6,
          3em 0 0 -0.5em #3f8cf6, 2em 2em 0 -0.5em #3f8cf6, 0 3em 0 0 #3f8cf6,
          -2em 2em 0 0.2em #3f8cf6, -3em 0 0 0 #3f8cf6,
          -2em -2em 0 -0.5em #3f8cf6;
      }

      50% {
        box-shadow: 0 -3em 0 -0.5em #3f8cf6, 2em -2em 0 -0.5em #3f8cf6,
          3em 0 0 -0.5em #3f8cf6, 2em 2em 0 0 #3f8cf6, 0 3em 0 0.2em #3f8cf6,
          -2em 2em 0 0 #3f8cf6, -3em 0 0 -0.5em #3f8cf6,
          -2em -2em 0 -0.5em #3f8cf6;
      }

      62.5% {
        box-shadow: 0 -3em 0 -0.5em #3f8cf6, 2em -2em 0 -0.5em #3f8cf6,
          3em 0 0 0 #3f8cf6, 2em 2em 0 0.2em #3f8cf6, 0 3em 0 0 #3f8cf6,
          -2em 2em 0 -0.5em #3f8cf6, -3em 0 0 -0.5em #3f8cf6,
          -2em -2em 0 -0.5em #3f8cf6;
      }

      75% {
        box-shadow: 0 -3em 0 -0.5em #3f8cf6, 2em -2em 0 0 #3f8cf6,
          3em 0 0 0.2em #3f8cf6, 2em 2em 0 0 #3f8cf6, 0 3em 0 -0.5em #3f8cf6,
          -2em 2em 0 -0.5em #3f8cf6, -3em 0 0 -0.5em #3f8cf6,
          -2em -2em 0 -0.5em #3f8cf6;
      }

      87.5% {
        box-shadow: 0 -3em 0 0 #3f8cf6, 2em -2em 0 0.2em #3f8cf6,
          3em 0 0 0 #3f8cf6, 2em 2em 0 -0.5em #3f8cf6, 0 3em 0 -0.5em #3f8cf6,
          -2em 2em 0 -0.5em #3f8cf6, -3em 0 0 -0.5em #3f8cf6,
          -2em -2em 0 -0.5em #3f8cf6;
      }

      100% {
        box-shadow: 0 -3em 0 0.2em #3f8cf6, /*上*/ 2em -2em 0 0 #3f8cf6,
          /*右上*/ 3em 0 0 -0.5em #3f8cf6, /*右*/ 2em 2em 0 -0.5em #3f8cf6,
          /*右下*/ 0 3em 0 -0.5em #3f8cf6, /*下*/ -2em 2em 0 -0.5em #3f8cf6,
          /*左下*/ -3em 0 0 -0.5em #3f8cf6, /*左*/ -2em -2em 0 0 #3f8cf6; /*左上*/
      }
    }
  }

  .custom-progress-box {
    z-index: 2;
    width: 60%;
    margin-left: 32px;

    .progress-box {
      display: flex;
      align-items: center;
      width: 100%;
      margin: 15px auto;
      line-height: 12px;

      /deep/ .el-progress {
        width: 100%;
        // .el-progress-bar {
        //   line-height: 12px;
        //   border: 1px solid #4e7df9;
        //   padding: 1px;
        //   border-radius: 10px;

        //   .el-progress-bar__outer {
        //     background-color: transparent !important;

        //     .el-progress-bar__inner {
        //       line-height: 12px;
        //       background: var(--base-primary-color);
        //     }
        //   }
        // }
      }

      .custom-text {
        color: var(--base-primary-color);
        margin-left: 8px;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .time {
      color: var(--base-primary-color);
    }

    .description-box {
      color: var(--aside-bg-color);
      font-size: 14px;
      font-weight: 500;
      text-align: center;
    }
  }
}
</style>
